/*
* Created by Skeets 2017-12-04
* */

function onConfirm(obj)
{
  if (typeof obj !== "object") {
    obj = {};
  }

  if (typeof obj.skip !== "undefined" && obj.skip === true) {
    obj.yesCallback.apply(window, obj.yesParams);
    return true;
  }

  var defaults = {
    title      : lang.confirmDialog.confirm,
    msg        : lang.confirmDialog.continueText,
    yes        : lang.confirmDialog.continueShort,
    no         : lang.confirmDialog.cancel,
    yesCallback: function() {
    },
    yesParams  : [],
    yesType    : "success",
    noCallback : function() {
    },
    noParams   : []

  };

  // noinspection JSJQueryEfficiency
  if (!$("#langtomoConfirm").length) {
    $("body").append("<div id='langtomoConfirm' class='modal blockJoy' role='dialog' >" +
                     "<div class='modal-dialog' >" +
                     "<div class='modal-content bg-dark text-white' >" +
                     "<div class='modal-header' >" +
                     "<h4 class='modal-title' id='langtomoConfirmTitle' ></h4 >" +
                     "<button type='button' class='close' style='color:white;' data-dismiss='modal' >&times;</button >" +
                     "</div >" +
                     "<div class='modal-body' id='langtomoConfirmBody' >" +
                     "</div >" +
                     "<div class='modal-footer' >" +
                     "<button type='button' class='btn btn-dark' id='langTomoCofirmNo' ></button >" +
                     "<button type='button' class='btn btn-success' id='langTomoCofirmYes' ></button >" +
                     "</div >" +
                     "</div >" +
                     "</div >" +
                     "</div >");

  }


  for (var property in defaults) {
    if (defaults.hasOwnProperty(property)) {
      if (!obj.hasOwnProperty(property)) {
        obj[property] = defaults[property];
      }
    }
  }

  $("#langtomoConfirmTitle").html(obj.title);
  $("#langtomoConfirmBody").html(obj.msg);

  var yesButton = $("#langTomoCofirmYes");
  var noButton  = $("#langTomoCofirmNo");

  yesButton.attr("class", "btn btn-" + obj.yesType);

  // noinspection JSJQueryEfficiency
  var modal = $("#langtomoConfirm");

  yesButton.html(obj.yes);
  noButton.html(obj.no);
  yesButton.off().on("click", function() {
    obj.yesCallback.apply(window, obj.yesParams);
    modal.modal("hide");
  });

  noButton.off().on("click", function() {
    obj.noCallback.apply(window, obj.noParams);
    modal.modal("hide");
  });

  modal.modal("show");
}
